/**
 * Derive a normalized merchant label from free-text transaction names.
 * Mirror of Server/api/lib/merchantNormalization.js
 */

const MERCHANT_PATTERNS: ReadonlyArray<{ pattern: RegExp; merchant: string }> = [
  { pattern: /\buber\s+eats\b/i, merchant: "Uber Eats" },
  { pattern: /\b(rappi|pedidos\s*ya)\b/i, merchant: "Rappi" },
  { pattern: /\b(uber|cabify|didi|lyft|beat)\b/i, merchant: "Uber" },
  { pattern: /\b(spotify|netflix|disney\+?|hbo|youtube\s*premium|amazon\s+prime)\b/i, merchant: "Streaming" },
  { pattern: /\b(microsoft\s*365|office\s*365|openai|chatgpt|cursor|notion|adobe)\b/i, merchant: "Software" },
  { pattern: /\b(mercado\s*libre|mercadolibre)\b/i, merchant: "Mercado Libre" },
  { pattern: /\bamazon\b/i, merchant: "Amazon" },
  { pattern: /\b(ypf|shell|axion)\b/i, merchant: "Fuel" },
  { pattern: /\bsube\b/i, merchant: "SUBE" },
  { pattern: /\b(carrefour|coto|dia\b|jumbo|vea|disco\b)\b/i, merchant: "Supermarket" },
  { pattern: /\b(mcdonald|burger\s*king|starbucks|mostaza)\b/i, merchant: "Fast Food" },
  { pattern: /\bfarmacity\b/i, merchant: "Farmacity" },
  { pattern: /\bosde\b/i, merchant: "Osde" },
  { pattern: /\bswiss\s*medical\b/i, merchant: "Swiss Medical" },
  { pattern: /\bclaro\b/i, merchant: "Claro" },
  { pattern: /\bmovistar\b/i, merchant: "Movistar" },
  { pattern: /\bpersonal\b/i, merchant: "Personal" },
  { pattern: /\bedenor\b/i, merchant: "Edenor" },
  { pattern: /\bedesur\b/i, merchant: "Edesur" },
  { pattern: /\bmetrogas\b/i, merchant: "Metrogas" },
  { pattern: /\baysa\b/i, merchant: "AySA" },
  { pattern: /\b(cablevision|telecentro)\b/i, merchant: "Cablevision" },
];

const NOISE_TOKENS = /\b(ars|usd|payu|debito|credito|compra|pago|transferencia|varios|consumo)\b/gi;

export function normalizeMerchant(name: string | null | undefined): string | null {
  const text = (name || "").toString().trim();
  if (!text) return null;

  for (const { pattern, merchant } of MERCHANT_PATTERNS) {
    if (pattern.test(text)) return merchant;
  }

  const cleaned = text
    .toLowerCase()
    .replace(NOISE_TOKENS, " ")
    .replace(/[#\d.,]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const words = cleaned.split(" ").filter((w) => w.length > 2);
  if (words.length === 0) return null;

  return words
    .slice(0, 2)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
